<!-- BEGIN: Header-->
<nav class="header-navbar navbar-expand-md navbar navbar-with-menu navbar-without-dd-arrow fixed-top navbar-semi-dark">
  <div class="navbar-wrapper">
    <div class="navbar-container content">
      <div class="collapse navbar-collapse show" id="navbar-mobile">
        <ul class="nav navbar-nav mr-auto float-left">
        </ul>

        <ul class="nav navbar-nav float-right">

          <li class="nav-item dropdown">
            <a nz-dropdown class="dropdown-toggle nav-link" [nzDropdownMenu]="menu" nzTrigger="click">
              {{ languageService.current === 'ar' ? 'العربية' : 'English' }}
              <i nz-icon nzType="down"></i>
            </a>

            <nz-dropdown-menu #menu="nzDropdownMenu">
              <ul style="background-color: white; box-shadow: 0 2px 8px rgba(0,0,0,0.15); padding: 0;" nz-menu>
                <li class="dropdown-item" nz-menu-item (click)="changeLang('en')">English</li>
                <li class="dropdown-item" nz-menu-item (click)="changeLang('ar')">العربية</li>
              </ul>
            </nz-dropdown-menu>
          </li>
          <li class="dropdown dropdown-user nav-item">
            <a class="dropdown-toggle nav-link dropdown-user-link" href="#" data-toggle="dropdown"
              style="padding: 1.5rem 1rem;">
              <span class="ft ft-user" style="font-size: 26px;"></span>
              <!-- <span class="avatar">
              <img [src]="profileService.profile.imageUrl | imageUrl:'profile' | safe:'url'" alt="">
            </span> -->
          </a>
          <div class="dropdown-menu dropdown-menu-right">
            <div class="arrow_box_right">
              <!-- <a class="dropdown-item" href="#"><span class="avatar avatar-online"><img src="app-assets/images/portrait/small/avatar-s-19.png" alt="avatar"><span class="user-name text-bold-700 ml-1">John Doe</span></span></a>
              <div class="dropdown-divider"></div> -->
              <a class="dropdown-item" [routerLink]="['/edit-profile']"><i class="ft ft-user"></i>Edit Profile</a>
              <!-- <a class="dropdown-item" [routerLink]="['/privacy']"><i class="ft ft-lock"></i>Privacy</a>
              <a class="dropdown-item" [routerLink]="['/settings']"><i class="ft ft-settings"></i>Settings</a> -->
              <div class="dropdown-divider"></div>
              <a class="dropdown-item" (click)="auth.logout()"><i class="ft ft-power"></i>Logout</a>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</div>
</nav>
<!-- END: Header-->

<!-- BEGIN: Main Menu-->
<div class="main-menu menu-fixed menu-dark menu-accordion menu-shadow" data-scroll-to-active="true">
  <div class="navbar-header">
    <ul class="nav navbar-nav flex-row position-relative">
      <li class="nav-item mr-auto">
        <a class="navbar-brand" href="index.html">
          <img height="30" alt="" src="assets/images/logo/gymerz_white.png" />
          <h3 class="brand-text">Admin</h3>
        </a>
      </li>
      <li class="nav-item d-none d-md-block nav-toggle"><a class="nav-link modern-nav-toggle pr-0"
        data-toggle="collapse"><i class="toggle-icon ft-disc font-medium-3" data-ticon="ft-disc"></i></a></li>
        <li class="nav-item d-md-none"><a class="nav-link close-navbar"><i class="ft-x"></i></a></li>
      </ul>
    </div>
    <div class="navigation-background"></div>
    <div class="main-menu-content">
        <ul class="navigation navigation-main" id="main-menu-navigation" data-menu="menu-navigation">
          <li class=" nav-item">
            <a [routerLink]="['/home']"><i class="ft ft-home"></i><span class="menu-title" data-i18n="">Home</span></a>
          </li>
          <li class=" nav-item">
            <a [routerLink]="['/orders']">
              <i class="ft ft-link-2"></i>
              <span class="menu-title" data-i18n="">Orders</span>
            </a>
          </li>
          <li class=" nav-item">
            <a [routerLink]="['/coupons']">
              <i class="ft">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                  class="feather feather-gift">
                  <polyline points="20 12 20 22 4 22 4 12" />
                  <rect x="2" y="7" width="20" height="5" />
                  <line x1="12" y1="22" x2="12" y2="7" />
                  <path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z" />
                  <path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z" />
                </svg>
              </i>
              <span class="menu-title" data-i18n="">Coupons</span>
            </a>
          </li>
          <li class=" nav-item">
            <a [routerLink]="['/reported-users']"><i class="ft ft-message-square"></i><span class="menu-title"
          data-i18n="">Reported users</span></a>
        </li>
        <li class=" nav-item">
          <a [routerLink]="['/reported-posts']"><i class="ft ft-tag"></i><span class="menu-title" data-i18n="">Reported
        posts</span></a>
      </li>
      <li class=" nav-item">
        <a [routerLink]="['/reported-comments']"><i class="ft ft-calendar"></i><span class="menu-title"
      data-i18n="">Reported comments</span></a>
    </li>
    <li class=" nav-item">
      <a [routerLink]="['/reported-groups']"><i class="ft ft-calendar"></i><span class="menu-title"
    data-i18n="">Reported groups</span></a>
  </li>

  <li class=" nav-item">
    <a [routerLink]="['/verification-requests']"><i class="ft ft-check"></i><span class="menu-title"
  data-i18n="">Verification requests</span></a>
</li>

@if (auth.isAdminAtLeast) {
  <li class=" nav-item">
    <a [routerLink]="['/users']"><i class="ft ft-users"></i><span class="menu-title" data-i18n="">Users</span></a>
  </li>
}
@if (auth.isAdminAtLeast) {
  <li class=" nav-item">
    <a [routerLink]="['/staff']"><i class="ft ft-users"></i><span class="menu-title" data-i18n="">Staff</span></a>
  </li>
}

<li class=" nav-item">
  <a [routerLink]="['/send-notifications']"><i class="ft ft-bell"></i><span class="menu-title" data-i18n="">Send
notifications</span></a>
</li>
<li class=" nav-item">
  <a [routerLink]="['/cities']"><i class="ft ft-map-pin"></i><span class="menu-title"
data-i18n="">Cities</span></a>
</li>
<li class=" nav-item">
  <a [routerLink]="['/banners']">
    <i class="ft ft-monitor"></i>
    <span class="menu-title" data-i18n="">Banners</span>
  </a>
</li>
<li class=" nav-item">
  <a [routerLink]="['/partnerships']">
    <i class="ft ft-link-2"></i>
    <span class="menu-title" data-i18n="">Partnerships</span>
  </a>
</li>
<li class=" nav-item">
  <a [routerLink]="['/report-reasons']"><i class="ft ft-map-pin"></i><span class="menu-title"
data-i18n="">Report Reasons</span></a>
</li>
<li class=" nav-item">
  <a [routerLink]="['/goals']"><i class="ft ft-map-pin"></i><span class="menu-title"
data-i18n="">Goals</span></a>
</li>
<li class=" nav-item">
  <a [routerLink]="['/verification-request-rejections']"><i class="ft ft-map-pin"></i><span class="menu-title"
data-i18n="">Verification Rejections</span></a>
</li>
<li class=" nav-item">
  <a [routerLink]="['/logs']"><i class="ft ft-map-pin"></i><span class="menu-title" data-i18n="">Logs</span></a>
</li>
<li class=" nav-item">
  <a [routerLink]="['/home-order']"><i class="ft ft-align-center"></i><span class="menu-title" data-i18n="">Home
order</span></a>
</li>
<li class=" nav-item">
  <a [routerLink]="['/settings']"><i class="ft ft-settings"></i><span class="menu-title" data-i18n="">Developer
Mode</span></a>
</li>
</ul>
</div>
</div>
<!-- END: Main Menu-->


<!-- BEGIN: Content-->
<div class="app-content content">
  <div class="content-wrapper">
    <div class="content-header row"></div>
    <div class="content-body">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
<!-- <div class="app-content content" *ngIf="showWrapper">
<div class="content-wrapper">
  <div class="content-wrapper-before" *ngIf="showContentWrapperBefore"></div>
  <div class="content-header row"></div>
  <div class="content-body">
    <router-outlet></router-outlet>
  </div>
</div>
</div>

<div class="app-content content " style="display: flex;" *ngIf="!showWrapper">
  <router-outlet></router-outlet>
</div> -->
<!-- END: Content-->


<!-- BEGIN: Footer-->
<!-- <a class="btn btn-try-builder btn-bg-gradient-x-purple-red btn-glow white" href="https://www.themeselection.com/layout-builder/horizontal" target="_blank">Try Layout Builder</a> -->
<!-- <footer class="footer footer-static footer-light navbar-border navbar-shadow">
<div class="clearfix blue-grey lighten-2 text-sm-center mb-0 px-2"><span class="float-md-left d-block d-md-inline-block">2019 &copy; Copyright <a class="text-bold-800 grey darken-2" href="https://themeselection.com" target="_blank">ThemeSelection</a></span>
<ul class="list-inline float-md-right d-block d-md-inline-blockd-none d-lg-block mb-0">
  <li class="list-inline-item"><a class="my-1" href="https://themeselection.com/" target="_blank"> More themes</a></li>
  <li class="list-inline-item"><a class="my-1" href="https://themeselection.com/support" target="_blank"> Support</a></li>
</ul>
</div>
</footer> -->
<!-- END: Footer-->
